"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
if (process.env.BROWSER) {
    require('./index.less');
}
class Emoji extends React.PureComponent {
    render() {
        return React.createElement(React.Fragment, null, this.parseEmojiContent());
    }
    parseEmojiContent() {
        if (!this.props.message) {
            return '';
        }
        return this.props.message.split(/(\[.*?\])(?!\.webp\")/).map((item) => {
            if (/(\[.*?\])(?!\.webp\")/.test(item)) {
                if (this.props.onEmojiMatch) {
                    if (this.props.onEmojiMatch(item)) {
                        return this.props.onEmojiMatch(item);
                    }
                }
                return React.createElement("img", { key: Math.random() + '', className: 'emoji', src: `${this.props.urlPrefix}/${item}.webp` });
            }
            else {
                return item;
            }
        });
    }
}
exports.default = Emoji;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBK0I7QUFDL0IsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRTtJQUNyQixPQUFPLENBQUMsY0FBYyxDQUFDLENBQUM7Q0FDM0I7QUFNRCxNQUFxQixLQUFNLFNBQVEsS0FBSyxDQUFDLGFBQXlCO0lBQ3ZELE1BQU07UUFDVCxPQUFPLG9CQUFDLEtBQUssQ0FBQyxRQUFRLFFBRWQsSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBRWYsQ0FBQztJQUN0QixDQUFDO0lBRU8saUJBQWlCO1FBQ3JCLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sRUFBRTtZQUNyQixPQUFPLEVBQUUsQ0FBQztTQUNiO1FBQ0QsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsdUJBQXVCLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRTtZQUNsRSxJQUFJLHVCQUF1QixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRTtnQkFDcEMsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFlBQVksRUFBRTtvQkFDekIsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsRUFBRTt3QkFDL0IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztxQkFDeEM7aUJBQ0o7Z0JBQ0QsT0FBTyw2QkFBSyxHQUFHLEVBQUUsSUFBSSxDQUFDLE1BQU0sRUFBRSxHQUFHLEVBQUUsRUFDL0IsU0FBUyxFQUFFLE9BQU8sRUFBRSxHQUFHLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsSUFBSSxJQUFJLE9BQU8sR0FBSSxDQUFDO2FBQzNFO2lCQUFNO2dCQUNILE9BQU8sSUFBSSxDQUFDO2FBQ2Y7UUFDTCxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7Q0FDSjtBQTNCRCx3QkEyQkMifQ==